export function projectMissionProgress(prevMissions, agg) {
  const list = Array.isArray(prevMissions) ? prevMissions : [];
  const a = agg && typeof agg === 'object' ? agg : {};
  const number = (value) => Number(value || 0) || 0;
  const clamp = (value, low, high) => Math.max(low, Math.min(high, value));

  const clearedFire = number(a.clearedFire ?? a.clear_element_fire ?? a.fire ?? a.cleared_fire);
  const clearedWater = number(a.clearedWater ?? a.clear_element_water ?? a.water ?? a.cleared_water);
  const clearedAir = number(a.clearedAir ?? a.clear_element_air ?? a.air ?? a.cleared_air);
  const clearedEarth = number(a.clearedEarth ?? a.clear_element_earth ?? a.earth ?? a.cleared_earth);
  const starsCreated = number(a.starsCreated ?? a.make_star ?? a.stars ?? a.createdStars);
  const stripesActivated = number(a.stripesActivated ?? a.activate_stripe ?? a.stripes ?? a.activatedStripes);
  const starsActivated = number(a.starsActivated ?? a.activateStar ?? a.activate_star ?? a.activatedStars);
  const specialActivations = number(a.specialActivations ?? a.activate_any_special ?? (starsActivated + stripesActivated));
  const cascades = Math.max(0, number(a.cascades ?? a.cascadeDepth ?? a.maxCascade ?? a.bestCascade ?? a.best_cascade ?? a.cascade ?? a.cascadeCount));
  const combo3 = number(a.combo_3 ?? a.combo3);
  const combo4 = number(a.combo_4 ?? a.combo4);
  const combo5 = number(a.combo_5 ?? a.combo5);
  const combos3Plus = number(a.combos_3plus ?? a.combos3Plus ?? a.combo_3plus ?? a.combo3plus ?? (combo3 + combo4 + combo5));
  const score = number(a.score ?? a.finalScore ?? a.scoreReach ?? a.score_reach);

  return list.map((mission) => {
    const type = String(mission?.type || '').toLowerCase();
    const target = number(mission?.target);
    const previous = number(mission?.progress);
    let add = 0;

    if (type.includes('fire')) add = clearedFire;
    else if (type.includes('water')) add = clearedWater;
    else if (type.includes('air')) add = clearedAir;
    else if (type.includes('earth')) add = clearedEarth;
    if (type === 'clear_element_any') add = clearedFire + clearedWater + clearedAir + clearedEarth;
    if (type.includes('star') || type.includes('estrella') || type.includes('make_star')) add = starsCreated;
    if (type.includes('stripe') || type.includes('rayo') || type.includes('activate_stripe')) add = stripesActivated;
    if (type === 'activate_any_special') add = specialActivations;
    if (type.includes('cascade') || type.includes('cascada')) add = cascades;
    if (type.includes('combo')) {
      if (type.includes('5')) add = combo5 || combos3Plus;
      else if (type.includes('4')) add = combo4 || combos3Plus;
      else add = combos3Plus;
    }

    const nextProgress = (type.includes('score') || type.includes('reach'))
      ? Math.max(previous, score)
      : previous + add;
    const progress = target > 0 ? clamp(nextProgress, 0, target) : nextProgress;
    const done = !!mission?.done || (target > 0 && progress >= target);
    return {
      ...mission,
      progress,
      done,
      completed: done,
      current: done ? Math.max(target, progress) : progress,
    };
  });
}
